var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "radio-btn" },
    _vm._l(_vm.items, function(item, i) {
      return _c("label", { key: i, staticClass: "radio-btn__label" }, [
        _c("input", {
          attrs: { type: "radio", name: item.name },
          domProps: { value: item.value, checked: item.checked },
          on: {
            change: function($event) {
              return _vm.$emit("update:value", item.value)
            }
          }
        }),
        _c("span", { staticClass: "radio-btn__span" }),
        _c("span", { staticClass: "radio-btn__name" }, [
          _vm._v("\n        " + _vm._s(item.label) + "\n      ")
        ])
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-094140fa", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-094140fa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/_UI/BaseRadio.vue
// module id = fBLg
// module chunks = 13